export default {
    common:{
        dateFormat: "DD.MM.YYYY",
        currency:  "CHF {value}",
        choose:     "Choisir",
        next:       "Continuer",
        previous:   "Retour",
        bestChoice: "Le meilleur choix",
        and:        "et",
        or:         "ou",
        edit:       "Modifier",
        basket:     "Panier",
        yourStudio: "Votre club",
        yourPlan:   "Votre abonnement",
        yourAddition: "Vos extras",
        noAddition: "Continuer sans extra",
        opening: "Ouverture {date}"
    },
    widget:{
        studio:{
            searchPlaceholder: "Recherchez un code postal ou une ville",
            clubList: "Liste des clubs",
            mapView : "Vue de la carte"
        },
        basket:{
            totalAmount: "Total",
        },
        user:{
            genderFemale: "Feminin",
            genderMale: "Masculin",
            genderDivers: "Divers",
            firstname: "Prénom",
            lastname: "Nom",
            email: "E-Mail",
            phone: "Numéro de téléphone",
            birthday: "Date de naissance",
        },
        address:{
            street: "Rue",
            streetno: "Numéro",
            zipcode: "Code postal",
            city: "Ville",
            country: "Pays",
        },
        membership:{
            membership: "Abonnement",
            startOfMembership: "Début de l'abonnement",
            trainingsStart: "Début de l´entraînement de {date}",
            rightAway: "immédiatement",
        }
    },
    footer:{
            backToHomepage: "retour au site",
            imprint: "Impressum",
            dataProtection: "Protection des données",
            paymentOptions: "Options de paiement",
        },
    steps: {
        step1_1: "Choisissez un club",
        step1_2: "Choisir l'abonnement",
        step1_3: "Choisir des extras",
        step1_4: "Résumé",
        step2_1: "Données personnelles",
        step2_2: "Adresse",
        step2_3: 'Payment',
        step2_4: "Check-Out",
    },
    pages:{
        selectClub:{
            headline: "Choisissez votre club",
        },
        selectContract: {
            headline: "Choisir l'abonnement",
            choosePlan: "Choisissez votre abonnement",
            chooseRuntime: "Choisissez la durée de votre abonnement",
            basisPlan: "Notre offre Core",
            premiumPlan: "Notre offre Premium",
            planPoints: [
                "Basefit.ch app avec info en direct sur le nombre de visiteurs dans le club",
                "Live Group Fitness On-Demand",
                "Accès à tous les clubs",
                "Votre ami s'entraîne gratuitement le week-end",
                "Pas de délai de préavis",
                "Suspendre votre abonnement",
                "Frais d'inscription",
                "Monatlich kündbar",
            ]
        },
        selectAddition:{
            headline: "Rendre votre abonnement complèt",
            unselectAddition: "Continuer sans extra",
        },
        overview:{
            headline: "Votre résumé",
            yourData: "Votre détails",
        },
        selectData:{
                dataProtection: "Protection des données",
                checkboxDataPolice: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam {DP_URL}.",
                checkboxNewsletter: "Oui, je souhaite recevoir des informations publicitaires et des informations sur d'autres produits de Basefit.ch et de ses partenaires.",
                footerActionText: "Rempliez s'il vous plaît",
                yourData: "Votre détails",
            },
        selectAddress:{
                yourAddress: "Votre Adresse",
                yourMembership: "Abonnement",
                howDoYouKnow: "Comment vous nous connaissez?",
                footerName: "Bonjour {fname}",
                footerActionText: "Veuillez entrer votre adresse",
            },
            selectPayment:{
                yourPaymentOptions: "Vos modes de paiement",
                healthInsuranceRefund: "Remboursement de l'assurance maladie",
                checkboxHealthInsuranceRefund: "Oui, je souhaite bénéficier du programme de bonus Swica - jusqu'à 527,25 CHF de remboursement – et être contacté. Je consens au transfert de mes données à Swica. Vous pouvez trouver plus d'informations {url}.",
                checkboxUrlText: "ici",
            },
        checkOut:{
            yourOverview: "Votre résumé",
            yourData: "Votre détails",
            address: "Adresse",
            yourMembershipStart: "Votre début de l'abonnément",
            paymentInformation: "Informations de paiement",
            couponRedeem:  "Utiliser",
            coupon:    "Code de bon",
            couponAccept: "Le code du bon {coupon} est accepté.",
            couponDecline: "Le code du bon {coupon} n'est pas accepté.",
            orderForFee: "Payer",
            checkboxAGB: "J'accepte les {url_agb} et les {url_dataprotection} de Basefit.ch.",
            checkboxURLAGB: "AGB",
        },
    },
};